// The subject-neutral strings of the portal-access management UI (Kund:innen-Zugang / Zugang
// Ehrenamtliche): both staff pages render the same cards from the shared `portal-access` component
// set, so every string that does not name the subject lives here exactly once. Subject-specific
// sentences (titles, descriptions, confirmation bodies — German declension makes noun interpolation
// fragile) stay in `clientAccess` and `volunteers.access` and are injected as texts.
const portalAccess = {
  loading: "Zugriffsstatus wird geladen",
  loadError: "Der Zugriffsstatus konnte nicht geladen werden.",
  currentStatus: "Aktueller Zugriffsstatus",
  state: {
    notGranted: "Nicht erteilt",
    invitationSent: "Einladung versendet",
    registered: "Freigeschalten",
    locked: "Gesperrt",
  },
  statusRows: {
    access: "Zugang",
    accessNotGranted: "Noch nicht erteilt",
    email: "Freigeschaltete E-Mail-Adresse",
    identityDocumentType: "Ausweisart",
    identityDocumentNumber: "Ausweisnummer",
    identityDocumentIssuingAuthority: "Ausstellende Behörde",
    identityDocumentValidUntil: "Ausweis gültig bis",
    lastSent: "Zuletzt versendet",
    registration: "Registrierung",
    registrationPending: "Ausstehend",
    registrationCompleted: "Abgeschlossen",
    secondFactor: "Zweiter Faktor",
    secondFactorNone: "Nicht eingerichtet",
    // The state is read live from Keycloak; an unreachable Keycloak degrades this one row instead
    // of the whole card, so sperren/entsperren stay usable.
    secondFactorUnknown: "Derzeit nicht abrufbar",
  },
  // Keyed by the identity provider's credential type. An unknown type falls back to the raw value,
  // so a method added at the identity provider shows up instead of an empty row.
  secondFactorMethods: {
    otp: "Authenticator-App",
    email: "Code per E-Mail",
    sms: "Code per SMS",
  },
  invitation: {
    title: "Initiale Freischaltung",
    send: "Freischalten & Einladung senden",
    sendSuccess: "Einladung versendet",
    sendError: "Einladung konnte nicht versendet werden",
  },
  pending: {
    title: "Einladung ausstehend",
    resend: "Einladung erneut versenden",
    resendPossibleAt: "Erneut möglich ab {{dateTime}}",
    resendSuccess: "Einladung erneut versendet",
    resendError: "Einladung konnte nicht erneut versendet werden",
    // Withdraw is offered for client subjects only today; the confirmation body names the
    // Klient:in, so it moves into a subject override once volunteers gain the action.
    withdraw: "Einladung zurückziehen",
    confirmWithdrawTitle: "Einladung zurückziehen?",
    confirmWithdrawText:
      "Der Registrierungslink wird ungültig. Die Klient:in kann sich damit nicht mehr registrieren. Der Zugang kann jederzeit erneut freigeschalten werden. Ein Aktenvermerk vom Typ „Systemmeldung“ wird erstellt.",
    confirmWithdrawConfirm: "Zurückziehen",
    withdrawSuccess: "Einladung zurückgezogen",
    withdrawError: "Einladung konnte nicht zurückgezogen werden",
  },
  manage: {
    title: "Zugang verwalten",
    lock: "Benutzer sperren",
    unlock: "Benutzer entsperren",
    resetPassword: "Passwort zurücksetzen",
    lockedInfo: "Der Benutzer ist derzeit gesperrt und kann sich nicht anmelden.",
    confirmLockTitle: "Benutzer sperren?",
    confirmLockConfirm: "Sperren",
    lockSuccess: "Benutzer gesperrt",
    lockError: "Benutzer konnte nicht gesperrt werden",
    confirmUnlockTitle: "Benutzer entsperren?",
    confirmUnlockConfirm: "Entsperren",
    unlockSuccess: "Benutzer entsperrt",
    unlockError: "Benutzer konnte nicht entsperrt werden",
    confirmResetTitle: "Passwort zurücksetzen?",
    // Appended to the subject-specific confirmation body only when a second factor is set up.
    confirmResetSecondFactor:
      "Der eingerichtete zweite Faktor wird beim Setzen des neuen Passworts ebenfalls zurückgesetzt.",
    confirmResetConfirm: "Zurücksetzen",
    resetSuccess: "E-Mail zum Zurücksetzen des Passworts versendet",
    resetError: "Passwort konnte nicht zurückgesetzt werden",
    // Remove is offered for client subjects only today, same caveat as withdraw.
    removeUser: "Benutzer entfernen",
    confirmRemoveUserTitle: "Benutzer entfernen?",
    confirmRemoveUserText:
      "Der Portalbenutzer wird gelöscht und die Verknüpfung zur Klient:in aufgehoben. Ein Zugang kann danach neu erteilt werden. Ein Aktenvermerk vom Typ „Systemmeldung“ wird erstellt.",
    confirmRemoveUserConfirm: "Entfernen",
    removeUserSuccess: "Portalbenutzer entfernt",
    removeUserError: "Portalbenutzer konnte nicht entfernt werden",
  },
};

export default portalAccess;
